import React, { useEffect, useState } from "react";
import API from "../../services/api";
import { SlIcon } from "@shoelace-style/shoelace/dist/react";
import TableSkelton from "../../shared/TableSkelton";
import NoDataFound from "../../shared/NoDataFound";
import { useNavigate } from "react-router";
import { getBrandOptions, toLakhs } from "../../utils/constants";
import { Toast } from "../../shared/Toast";
import * as XLSX from "xlsx";
import ScrollContainer from "react-indiana-drag-scroll";
import { SlSelect,SlOption } from "@shoelace-style/shoelace/dist/react";

function RevenueSummary() {
    const navigate = useNavigate()
  const [data, setData] = useState([]);
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedType,setSelectedType] = useState('all')
  const fetchData = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/monthly/revenue",
        method: "POST",
        responseType: "json",
        data: {
          type:selectedType
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
      else if(res.code  === 401){
        navigate('/')
      }
    } catch (error) {
      console.error(error);
    }
    finally {
      setLoader(false);
    }
  };

  const getdownloadData = async () => {
    setDownloadLoader(true);
    try {
      const tableData = [
        [
          "Rs Cr",
          "Target",
          "Achieved",
          "Last Year",
          "Growth %",
        ],
        [
          "This Month",
            data.target?.month,
            (data.achievedThisYear?.month || 0),
            (data.achievedLastYear?.month || 0),
            calculatePercentage(data.achievedThisYear?.month || 0,data.achievedLastYear?.month || 0)
        ],
        ["Year to Date",
            data.target?.year,
            (data.achievedThisYear?.year),
            (data.achievedLastYear?.year),
            calculatePercentage(data.achievedThisYear?.year || 0,data.achievedLastYear?.year || 0)]
      ]
      const worksheet = XLSX.utils.aoa_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Revenue Summary");

      // Write the Excel file and trigger download
      XLSX.writeFile(workbook, `Revenue_Summary.xlsx`);
    } catch (error) {
      console.error(error, "Download Revenue Summary");
      Toast('error', 'Something went wrong')
    }
    finally{

      setDownloadLoader(false);
    }
  };
  const calculatePercentage = (current, previous) => {
    if (previous === 0) {
      return current === 0 ? "No growth" : "Infinity %";
    }
    const growth = ((current - previous) / previous) * 100;
    return `${growth.toFixed(2)} %`;
  };
  useEffect(() => {
    fetchData();
  }, [selectedType]);

  console.log(selectedType)
  return (
    <>
      <div className="d-flex justify-between items-center">
        <h5>Revenue Summary</h5>
        <div className="d-flex gap-3 items-center">
        <SlSelect size="small" value={selectedType} label="Team" onSlChange={(e) => {setSelectedType(e.target.value)}}>
        {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
        </div>
      </div>

      <ScrollContainer>
      <table className="table table-bordered mt-2">
        <thead>
          <tr>
            <th>Rs Cr</th>
            <th>Target</th>
            <th>Achieved</th>
            <th>Last Year</th>
            <th>% Growth</th>
          </tr>
        </thead>
        {(!loader && Object.keys(data).length > 0) ?<tbody>
          <tr>
            <th>This Month</th>
            <td>{toLakhs(data.target?.month || 0)}</td>
            <td>{toLakhs(data.achievedThisYear?.month || 0)}</td>
            <td>{toLakhs(data.achievedLastYear?.month || 0)}</td>
            <td>{calculatePercentage(data.achievedThisYear?.month || 0,data.achievedLastYear?.month || 0)}</td>
          </tr>
          <tr>
            <th>Year to Date</th>
            <td>{toLakhs(data.target?.year)}</td>
            <td>{toLakhs(data.achievedThisYear?.year)}</td>
            <td>{toLakhs(data.achievedLastYear?.year)}</td>
            <td>{calculatePercentage(data.achievedThisYear?.year || 0,data.achievedLastYear?.year || 0)}</td>
          </tr>
        </tbody> : loader ? <TableSkelton colspan={5} rowSpan={2} /> : <NoDataFound colspan={5} />}
      </table>
      </ScrollContainer>
    </>
  );
}

export default RevenueSummary;
